'use strict';

class SuperAppEnvironmentsController {
    constructor(SSUtilService, SSUserService, SSHttpService, OTPService, SSAlertService, SSConfirmationService) {
        const self = this;

        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.SSHttpService = SSHttpService;
        self.OTPService = OTPService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.ENVIRONMENT_LIVE = SHOWSUITE.ENVIRONMENT_LIVE;
        self.ENVIRONMENT_SANDBOX = SHOWSUITE.ENVIRONMENT_SANDBOX;
        self.ENVIRONMENT_STAGING = SHOWSUITE.ENVIRONMENT_STAGING;
        self.ENVIRONMENT_INTERNAL = SHOWSUITE.ENVIRONMENT_INTERNAL;

        // WEB-4732: no list request without the view key (the API answers 403004).
        if (self.canView()) {
            self.init();
        }
    }

    // ---- Permissions (WEB-4732, keys from WEB-4725; the main super user passes all) ----

    /** @returns {boolean} May open the page and see the list. */
    canView() {
        return this.SSUserService.isSuper() && this.SSUserService.hasPermission('SS_APP_ENVIRONMENTS_VIEW');
    }

    /** @returns {boolean} May add an account and edit one. */
    canEdit() {
        return this.SSUserService.hasPermission('SS_APP_ENVIRONMENTS_EDIT');
    }

    /** @returns {boolean} May delete an account. */
    canDelete() {
        return this.SSUserService.hasPermission('SS_APP_ENVIRONMENTS_DELETE');
    }

    init() {
        const self = this;

        self.app_environment_accounts = [];

        self.prepareAppEnvironments();
        self.getAppEnvironments();
    }

    getAppEnvironments(){
        let self = this;

        let url = 'sec/super/app-environments';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.app_environment_accounts = response.data.app_environment_accounts;
        });
    }

    updateAppEnvironment(environment){
        const self = this;

        self.appEnvironmentParams = {};
        self.appEnvironmentErrors = {};

        self.allowed_environments = [];
        $.each(self.ENVIRONMENTS_LIST, function(index, env){
            self.allowed_environments[env.name] = false;
        });

        self.is_enabled = false;
        self.UPDATE_PASSWORD = true;
        
        if(environment){
            self.appEnvironmentParams = angular.copy(environment);

            self.is_enabled = environment.is_enabled ? true : false;

            if(self.appEnvironmentParams.allowed_environments){
                var env_names = self.appEnvironmentParams.allowed_environments.split(',');
                $.each(env_names, function(i, name){
                    self.allowed_environments[name.trim()] = true;
                });
            }
            self.UPDATE_PASSWORD = false;
        }

        $('#updateAppEnvironmentModal').modal('show');
    }

    saveAppEnvironment(){
        const self = this;

        var allowed_environments = '';
        $.each(self.ENVIRONMENTS_LIST, function(index, env){
            if(self.allowed_environments[env.name] == true){
                allowed_environments += env.name + ", ";
            }
        });
        self.appEnvironmentParams.allowed_environments = (allowed_environments.substring(0, allowed_environments.lastIndexOf(','))).trim();

        if(!self.isValidInput()){
            return;
        }

        let url = 'sec/super/app-environments';
        let params = self.appEnvironmentParams;
        params.is_enabled = self.is_enabled ? 1 : 0;

        let handleResponse = function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'App environment updated successfully.');
            self.getAppEnvironments();
        };

        loading(true);
        if (self.appEnvironmentParams.id) {
            url += '/' + self.appEnvironmentParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    deleteAppEnvironment(environment){
        const self = this;

        if(!environment){
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you would like to delete this app environment?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {
                self._deleteAppEnvironment(environment);
            }
        );
    }

    _deleteAppEnvironment(environment){
        const self = this;

        let url = 'sec/super/app-environments/'+ environment.id +'/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'The app environment has been deleted successfully');
            self.getAppEnvironments();
        });
    }

    prepareAppEnvironments(){
        const self = this;

        self.ENVIRONMENTS_LIST = [
            {'id': self.ENVIRONMENT_LIVE, 'name': self.ENVIRONMENT_LIVE},
            {'id': self.ENVIRONMENT_SANDBOX, 'name': self.ENVIRONMENT_SANDBOX},
            {'id': self.ENVIRONMENT_STAGING, 'name': self.ENVIRONMENT_STAGING},
            {'id': self.ENVIRONMENT_INTERNAL, 'name': self.ENVIRONMENT_INTERNAL}
        ];
    }

    isValidInput(){
        const self = this;

        self.appEnvironmentErrors = {};
        let isValid = true;

        if(!self.appEnvironmentParams.username){
            self.appEnvironmentErrors.username = "Please enter user name";
            isValid = false;
        }
        if(self.UPDATE_PASSWORD){
            if(!self.appEnvironmentParams.password){
                self.appEnvironmentErrors.password = "Please enter password";
                isValid = false;
            }
            else if(self.appEnvironmentParams.password != self.appEnvironmentParams.confirm_password){
                self.appEnvironmentErrors.confirm_password = "Passwords must match with each other";
                isValid = false;
            }
        }
        if(!self.appEnvironmentParams.allowed_environments){
            self.appEnvironmentErrors.allowed_environments = "Please select allowed environment(s)";
            isValid = false;
        }

        return isValid;
    }

    hideModals(){
        const self = this;

        if ($('#updateAppEnvironmentModal').is(':visible')) $('#updateAppEnvironmentModal').modal('hide');
    }

}

SuperAppEnvironmentsController.$inject = ['SSUtilService', 'SSUserService', 'SSHttpService','OTPService', 'SSAlertService', 'SSConfirmationService'];
app.controller('SuperAppEnvironmentsController', SuperAppEnvironmentsController);
